export enum ETextSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
